<template>
  <div>
    <textarea
      data-gramm="false"
      ref="h2"
      v-model="part.content"
      placeholder="Type something"
      :disabled="state !== 'editor'"></textarea>
  </div>
</template>

<script>
  export default {
    props: ['part', 'state'],
    mounted() {
      this.autoHeight();
      if (this.part.justCreated) {
        this.$refs.h2.focus();
        delete this.part.justCreated;
      }
    },
    methods: {
      autoHeight() {
        this.$refs.h2.style.height = '5px';
        this.$refs.h2.style.height = this.$refs.h2.scrollHeight + 'px';
      }
    },
    watch: {
      'part.content': {
        handler() {
          this.autoHeight();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_reset-this";

  textarea {
    border: 0;
    background-color: transparent;
    font-size: 24px;
    width: 100%;
    resize: none;
    overflow: hidden;
    padding: 0;
    @extend .reset-this;
  }
</style>



// WEBPACK FOOTER //
// h2.vue?640275de